import React from "react";
import { CRMTabPage } from "../components/Complex/CRMTabPage/CRMTabPage";
import { CRMPageWrap } from "../components/Simple/CRMPageWrap/CRMPageWrap";
import { CRMAdminPageAssignJobsContainer, getUnsassignedJobsCount } from "../containers/CRMAdminPageAssignJobsContainer/CRMAdminPageAssignJobsContainer";
import { TContainerStateProps } from "../state/TContainerStateProps";
import { TAdminUserEditable } from "../../../domain/codecs/formEditable/AdminUserEditable";
import { CRMHomesMenuBarContainer } from "../containers/CRMHomesMenuBarContainer/CRMHomesMenuBarContainer";
import { CRMAdminPageKlyantContainer } from "../containers/CRMAdminPageKlyantContainer/CRMAdminPageKlyantContainer";
import { CRMAdminPageBearerTokenManagementContainer } from "../containers/CRMAdminPageBearerTokenManagementContainer/CRMAdminPageBearerTokenManagementContainer";
import { CRMLegalMenuBarContainer } from "../containers/CRMLegalMenuBarContainer/CRMLegalMenuBarContainer";
import { CRMProbateMenuBarContainer } from "../containers/CRMProbateMenuBarContainer/CRMProbateMenuBarContainer";
import { getCurrentBrandHostnameAndEnv } from "../../../domain/models/Enviroment";
import { CRMAdminCreateStaffUserContainer } from "../containers/CRMAdminCreateStaffUserContainer/CRMAdminCreateStaffUserContainer";
import { CRMAdminChangeStaffUserPasswordContainer } from "../containers/CRMAdminChangeStaffUserPasswordContainer/CRMAdminChangeStaffUserPasswordContainer";
import { CRMAdminEditStaffUserContainer } from "../containers/CRMAdminEditStaffUserContainer/CRMAdminEditStaffUserContainer";
import { CRMGuidesAdminReads } from "../components/CRM/CRMGuidesAdminReads/CRMGuidesAdminReads";
import { CRMCaseAutoAssignmentBlock } from "../components/Complex/CRMCaseAutoAssignmentBlock/CRMCaseAutoAssignmentBlock";
import { CRMEmailTemplatesBlock } from "../components/Complex/CRMEmailTemplatesBlock/CRMEmailTemplatesBlock";
import { CRMLendersBlock } from "../components/Complex/CRMLendersBlock/CRMLendersBlock";
import { CRMRoadblockAssignmentBlock } from "../components/Complex/CRMRoadblockAssignmentBlock/CRMRoadblockAssignmentBlock";

export const CRMAdminPage = (props: TContainerStateProps): JSX.Element => {

    const getAdminUsers = (): Array<TAdminUserEditable> => 
        props.state.forms.homes_admin_page.data.output.adminUsers
    ;

    const hasKlyantError = props.state.forms.homes_admin_page.data.output.klyant.hasError;

    const currentBrand = getCurrentBrandHostnameAndEnv("web", window.location.hostname);

    return (
        <CRMPageWrap>
            {/* MENU BAR */}
            {currentBrand === "sailhomes" && <CRMHomesMenuBarContainer {...props} />}
            {currentBrand === "saillegal" && <CRMLegalMenuBarContainer {...props} />}
            {currentBrand === "sailprobate" && <CRMProbateMenuBarContainer {...props} />}

            {/* BODY */}
            <CRMTabPage
                tabs={[
                    {
                        label: "Assign User Jobs",
                        icon: getUnsassignedJobsCount(getAdminUsers()) ? "error-outline" : undefined,
                        iconColor: "highlights-instructional-brick-0",
                        content: <CRMAdminPageAssignJobsContainer
                            dispatch={props.dispatch}
                            state={props.state}
                        />,
                    },
                    {
                        label: "Klyant",
                        icon: hasKlyantError ? "error-outline" : undefined,
                        iconColor: "highlights-instructional-brick-0",
                        content: <CRMAdminPageKlyantContainer
                            state={props.state}
                            dispatch={props.dispatch}
                        />,
                    },
                    {
                        label: "Bearer Token Management",
                        content: <CRMAdminPageBearerTokenManagementContainer
                            state={props.state}
                            dispatch={props.dispatch}
                        />
                    },
                    {
                        label: "Create Staff User",
                        content: <CRMAdminCreateStaffUserContainer
                        state={props.state}
                        dispatch={props.dispatch}
                    />
                    },
                    {
                        label: "Edit Staff Users",
                        content: <CRMAdminEditStaffUserContainer
                            state={props.state}
                            dispatch={props.dispatch}
                        />
                    },
                    {
                        label: "Change Staff User Password",
                        content: <CRMAdminChangeStaffUserPasswordContainer
                        state={props.state}
                        dispatch={props.dispatch}
                    />
                    },
                    {
                        label: "Guide read tracking",
                        content: <CRMGuidesAdminReads adminUsers={getAdminUsers()} />,
                    },
                    ...(currentBrand === "saillegal" ? [{
                        label: "Case Auto Assignment",
                        content: <CRMCaseAutoAssignmentBlock
                            assignmentForms={props.state.forms.case_assignment_page_form.children.case_auto_assignment_forms}
                            caseHandlers={props.state.forms.case_assignment_page_form.children.case_handlers}
                            onboardingManagers={props.state.forms.case_assignment_page_form.children.onboarding_managers}
                            onChange={(payload) => props.dispatch({
                                type: "CRM_CASE_AUTO_ASSIGNMENT_CHANGE",
                                payload,
                            })}
                        />,
                    },
                    {
                        label: "Roadblock Assignment",
                        content: <CRMRoadblockAssignmentBlock
                            assignmentForms={props.state.forms.roadblock_assignment_page_form.children.roadblock_assignment_forms}
                            onChange={(payload) => props.dispatch({
                                type: "CRM_ROADBLOCK_ASSIGNMENT_CHANGE",
                                payload,
                            })}
                        />,
                    }] : []),
                    ...(currentBrand === "saillegal" ? [{
                        label: "Email templates",
                        content: <CRMEmailTemplatesBlock
                            templateForms={props.state.forms.email_templates_form.children.email_template_forms}
                            onChange={(payload) => props.dispatch({
                                type: "CRM_EMAIL_TEMPLATE_CHANGE",
                                payload,
                            })}
                            onSave={(payload) => props.dispatch({
                                type: "CRM_EMAIL_TEMPLATE_SAVE",
                                payload,
                            })}
                        />,
                    }] : []),
                    ...(currentBrand === "saillegal" ? [{
                        label: "Lenders",
                        content: <CRMLendersBlock
                            lenderForms={props.state.forms.lenders_page_form.children.lender_forms}
                            onChange={(payload) => props.dispatch({
                                type: "CRM_LENDER_CHANGE",
                                payload,
                            })}
                        />,
                    }] : []),
                ]}
            />
        </CRMPageWrap>
    );
};
